export const statusColors = [
  '#F1B2EE',
  '#95D69A',
  '#61D8D6',
  '#AAC8FC',
  '#DAC584',
  '#FFB3B5',
  '#C8B8F5'
];

export const statusLevels = [
  {
    id: 0,
    name: 'Legal',
  },
  {
    id: 1,
    name: 'Partial Ban',
  },
  {
    id: 2,
    name: 'General Ban',
  }/*,
  {
    id: 3,
    name: 'Implicit Ban',
  },
  {
    id: 4,
    name: 'Under Consideration',
  }*/


];

export const useCaseLevels = [
  {
    id: 0,
    name: 'Retail',
  },
  {
    id: 1,
    name: 'Wholesale',
  },
  {
    id: 2,
    name: 'Both',
  },
  {
    id: 3,
    name: 'Undecided',
  }
];

export const accessLevels = [
  {
    id: 0,
    name: 'Account',
  },
  {
    id: 1,
    name: 'Token',
  },
  {
    id: 2,
    name: 'Both',
  },
  {
    id: 3,
    name: 'Undecided',
  }
];

export const infrastructureLevels = [
  {
    id: 0,
    name: 'Conventional',
  },
  {
    id: 1,
    name: 'DLT',
  },
  {
    id: 2,
    name: 'Both',
  },
  {
    id: 3,
    name: 'Undecided',
  }
];

export const architectureLevels = [
  {
    id: 0,
    name: 'Direct',
  },
  {
    id: 1,
    name: 'Hybrid',
  },
  {
    id: 2,
    name: 'Undecided',
  }
];